<template>
    <div class="bo-cell-button-popup">
        <slot
            name="button"
            :visible="visible"
            :activate="activate"
            :deactivate="deactivate"
            :toggle="toggle"
            :disabled="disabled"
        >
            <!-- Fallback Content / Default Content -->
            <button
                v-if="!disabled"
                :class="['btn', inputStyle]"
                type="button"
                @click="activate"
            >
                <slot
                    name="button_content"
                    buttonName="buttonName"
                    >{{ buttonName }}</slot
                >
            </button>
        </slot>
        <template v-if="visible">
            <slot
                name="content"
                :visible="visible"
                :activate="activate"
                :toggle="toggle"
                :deactivate="deactivate"
            >
            </slot>
        </template>
    </div>
</template>

<script>
export default {
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
        active: {
            type: Boolean,
            default: false,
        },
        buttonName: {
            type: String,
            default: "Activate",
        },
        inputStyle: {
            type: [String, Array],
            default: "",
        },
    },
    data: function () {
        return {
            visible: this.active,
        };
    },
    watch: {
        active(n, o) {
            document.body.classList.toggle("modal-open");
            this.visible = n;
        },
    },
    methods: {
        activate() {
            this.visible = true;
            this.$emit("activate", this.visible);
        },
        deactivate() {
            this.visible = false;
            this.$emit("deactivate", this.visible);
        },
        toggle() {
            this.visible ? this.deactivate() : this.activate();
        },
    },
};
</script>
